const competition = {
  //  赛程预告
  competition_time: `/tgdataApi/competition/competition_time.json`,
  //  参赛资格
  config: `/tgdataApi/competition/config.json`,
  //  参赛介绍
  family: `/tgdataApi/competition/family.json`,
  //  小组赛
  group: `/tgdataApi/competition/group.json`,
  //  淘汰赛
  eliminate: `/tgdataApi/competition/eliminate.json`,
  //  排名
  rank: `/tgdataApi/competition/rank.json`
};

export default competition;
